var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$classes['loading'],attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{class:_vm.$classes['path'],attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"4","stroke-miterlimit":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }